import React from 'react';
import { useParams } from 'react-router-dom';
import DetailGroupUserComponent from '../../../components/Admin/group_users/DetailGroupUserComponent';

const DetailGroupUserPage = () => {
    const params = useParams()
    return <DetailGroupUserComponent groupUserId={ params.groupUserId } />;
}

export default DetailGroupUserPage;